export default __webpack_public_path__ + "static/media/bustour1.5ec71ac1.jpg";